import { useEffect, useContext } from "react";

import { AppContext } from '../../context.js';

import { Close } from "../../files/icons/index.js";

function Error(props) {
  const { errors } = props;

  const context = useContext(AppContext);

  // Auto-dismiss errors after 5 seconds
  useEffect(() => {
    if (errors && errors.length > 0) {
      const timer = setTimeout(() => {
        // Remove the oldest error
        const oldestError = errors[0];
        if (oldestError) {
          context.removeError(oldestError.id);
        }
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [errors, context]);

  const removeError = (errorId) => {
    context.removeError(errorId);
  };

  const renderErrors = () => {
    if (!errors || errors.length === 0) {
      return null;
    }

    return errors.map((error, index) => (
      <div 
        key={error.id} 
        className="card shadowmore mb-2" 
        style={{
          width: 300,
          marginBottom: index < errors.length - 1 ? '8px' : '0'
        }}
      >
        <div className="card-header sm">
          <div className="d-flex justify-content-between align-items-center">
            <span className="typo-strong-175 text-danger">Error</span>
            <div className="item" onClick={() => removeError(error.id)}><Close height={16} width={16} color={'grey'} /></div>
          </div>
        </div>
        <div className="card-content sm">
          <div className="typo-normal-150">
            {error.message || 'An error occurred'}
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div 
      style={{
        position: 'fixed', 
        right: '20px', 
        top: '10px', 
        display: errors && errors.length > 0 ? 'block' : 'none',
        zIndex: 9999,
        maxHeight: '400px',
        overflowY: 'auto'
      }}
    >
      {renderErrors()}
    </div>
  );
}

export default Error;